import React, { useEffect, useState } from 'react';
import './Recommendations.scss';
import Button from '../../BaseComponents/Button';
import RecommendationsModal from './RecommendationsModal';
import RecommendationsTable, {
  SelectedCategoryType
} from './RecommendationsTable';
import {
  changeModalVisibility,
  setRecommendationToView
} from '../../../store/recommendationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import ViewRecommendationModal from './RecommendationsModal/ViewRecommendationModal';
import {
  Recommendation,
  RecommendationCategory
} from '../../../types/apiGeneratedTypes';
import { getRecommendationCategories } from '../../../api/recommendation';
import { toast } from 'react-toastify';
import Select from '../../BaseComponents/Select';

const Recommendations = () => {
  const [categories, setCategories] = useState<RecommendationCategory[]>([]);
  const [selectedCategory, setSelectedCategory] =
    useState<SelectedCategoryType>({ key: '', value: 'All' });
  const dispatch = useDispatch();
  const {
    isAddRecommendationModalOpened,
    recommendationToView,
    memberRecommendations
  } = useSelector((state: RootState) => state.recommendations);
  const assigned_doctor = JSON.parse(sessionStorage.getItem("assigned_doctor") ?? "false");
  const {admin: { role }} = useSelector((state: RootState) => state.admin);
  const visible = ((role !== "doctor") || (assigned_doctor && role === "doctor"));   

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getRecommendationCategories();
        setCategories([...response.categories]);
      } catch (error) {
        console.error('Error fetching categories:', error);
        toast.error('Error loading categories');
      }
    };
    fetchCategories();
  }, []);

  const onAssignRecommendationBtnClick = () => {
    dispatch(changeModalVisibility(true));
  };

  return (
    <div className='tests-container'>
      <div className='tests-header-row sideBarPad2'>
        <div className='d-flex align-items-center gap-2'>
          <Select
            name='section'
            placeholder='Select section'
            options={[
              { key: null, value: 'All' },
              ...categories.map((category) => ({
                key: category.id,
                value: category.name
              }))
            ]}
            selectedOption={selectedCategory}
            onChange={(option) => {
              setSelectedCategory(option);
            }}
            isError={false}
          />
          <span style={{ flexShrink: 0, marginLeft: '8px' }}>
            Recommendations (
            {memberRecommendations?.recommendations?.length || 0})
          </span>
        </div>
        {visible && 
        <Button
          isSecondary={true}
          text='Assign Recommendation'
          onClick={onAssignRecommendationBtnClick}
        />}
      </div>
      <RecommendationsTable selectedCategory={selectedCategory} />
      <RecommendationsModal
        isOpen={isAddRecommendationModalOpened}
        onClose={() => {
          dispatch(changeModalVisibility(false));
        }}
      />
      <ViewRecommendationModal
        isOpen={recommendationToView !== null}
        onClose={() => {
          dispatch(
            setRecommendationToView(undefined as unknown as Recommendation)
          );
        }}
      />
    </div>
  );
};

export default Recommendations;
